import { onMounted, nextTick, ref, onUnmounted, computed, watch, reactive, toRefs } from 'vue'
import Chart from 'apexcharts'

export default function useChart (params) {

  const chartOptions = computed(() => params.value)

  const chartContainer = ref(null)

  let chart = null
  
  onMounted(() => {
    nextTick(() => {
      if (chartContainer.value) {
        chartOptions.value.chart.width = chartContainer.value.offsetWidth - 2
        chartOptions.value.chart.height = chartContainer.value.offsetHeight - 20
        chartOptions.value.chart.type = 'line'
        chartOptions.value.chart.redrawOnParentResize = false
        chartOptions.value.chart.zoom = {
          enabled: true
        }
        chartOptions.value.chart.toolbar = {
          show: false
        }
        chartOptions.value.chart.sparkline = {
          enabled: false
        }

        chart = new Chart(chartContainer.value, chartOptions.value)

        chart.render()
      }
    })
  })

  onUnmounted(() => {
    chart && chart.destroy()
  })

  watch(
    () => chartOptions.value,
    () => {
      chart && chart.updateOptions(chartOptions.value)
    }
  )

  return {
    chartContainer,
    chartOptions,
  }
}

